import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { getIsOffline } from '../../store/selectors';

function Online({ isOffline, children }) {
  return (
    <>
      {!isOffline && children}
    </>
  );
}
Online.propTypes = {
  isOffline: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isOffline: getIsOffline(state),
});
export default connect(
  mapStateToProps,
  {},
)(Online);
